import React from 'react';
import Modal from '@material-ui/core/Modal';
import Box from '@material-ui/core/Box';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { makeStyles } from '@material-ui/core/styles';

var modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '480px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px',
    backgroundColor: '#fff',
    padding: '32px',
};

var useStyles = makeStyles(function() {
    return {
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
    };
});

var TicketDerivadoConfirmModal = function(props) {
    var classes = useStyles();
    var cantidadItems = props.cantidadItems || 0;
    var cantidadTareas = props.cantidadTareas || 0;

    var buildMensaje = function() {
        var partes = [];
        if (cantidadItems > 0) {
            partes.push(cantidadItems + ' repuesto' + (cantidadItems !== 1 ? 's' : ''));
        }
        if (cantidadTareas > 0) {
            partes.push(cantidadTareas + ' tarea' + (cantidadTareas !== 1 ? 's' : ''));
        }
        return partes.join(' y ');
    };

    return (
        <Modal
            open={props.open}
            onClose={props.onCancel}
            className={classes.modal}
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
        >
            <Fade in={props.open}>
                <Box sx={modalStyle}>
                    <div className="text-center">
                        <div className="mb-3">
                            <i className="la la-exclamation-triangle" style={{ fontSize: '48px', color: '#f0ad4e' }}></i>
                        </div>
                        <h4 className="mb-3">
                            <strong>Items sin realizar</strong>
                        </h4>
                        <p className="text-muted mb-4">
                            Quedaron <strong>{buildMensaje()}</strong> sin realizarse.
                            <br />
                            ¿Querés generar un ticket correctivo derivado con esos elementos?
                        </p>
                        <div>
                            <button
                                type="button"
                                className="btn btn-primary mr-2"
                                onClick={props.onConfirm}
                            >
                                <i className="fa fa-check-circle"></i> Sí, generar ticket
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={props.onCancel}
                            >
                                <i className="fa fa-times-circle"></i> No, continuar
                            </button>
                        </div>
                    </div>
                </Box>
            </Fade>
        </Modal>
    );
};

export default TicketDerivadoConfirmModal;
